import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import firebase from '../../Config/Firebase'
import generator from 'generate-password'
import { async } from 'q';


const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  progress: {
    margin: theme.spacing(2),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
});



class App extends Component {
  constructor() {
    super()
    this.state = {
      added: false,
      email: "",
      password: "",
      error: ""
    }
  }


  componentDidMount() {
    this.generatePassword()
  }

  signup = async () => {
    this.setState({ creating: true })
    firebase.auth().createUserWithEmailAndPassword(this.state.email + "@gmail.com", this.state.password).then((user) => {
      //console.log(user.user.uid)

      firebase.database().ref(`group/${user.user.uid}`).set({
        groupId: this.state.email,
        groupPassword: this.state.password


      }).then(() => {
        this.setState({ creating: false })
        this.setState({ added: true }, () => {
          this.generatePassword()
        })
        setTimeout(() => {
          this.setState({ added: false })
        }, 3000);
      })

    }).catch((error) => {
      //console.log(error)
      this.setState({ error: error.message });
      this.setState({ creating: false })
      setTimeout(() => {
        this.setState({ error: "" })
      }, 3000);
    })

  }


  generatePassword = () => {
    var password = generator.generate({
      length: 8,
      numbers: true
    });
    this.setState({ password: password })
  }



  render() {

    const { classes } = this.props;
    return (
      <div className="login">

        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>

            <Typography component="h1" variant="h5">
              Create Group
         </Typography>
            <form className={classes.form} noValidate>
              <TextField
                onChange={(e) => { this.setState({ email: e.target.value }) }}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="id"
                label="Group ID"
                name="id"

                autoFocus
              />

              {this.state.creating ? (<div style={{ width: "100%" }}><CircularProgress style={{ marginTop: "10vh" }} /></div>) : (<Button

                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={this.signup}
              >
                Create Group
           </Button>)}



            </form>
          </div>

          {this.state.added && <div style={{ color: "#000080", fontFamily: "Roboto" }}><p>Group Successfully Created</p></div>}
          {this.state.error !== "" && <div style={{ color: "#000080", fontFamily: "Roboto" }}><p>{this.state.error}</p></div>}
        </Container>
      </div>
    )
  }
}

export default withStyles(styles)(App);